module.exports = __webpack_public_path__ + "img/inside-front.7f4b6697.svg";